<ejs-maps
  id="map-forecast-complete-access"
  style="display: block;"
  [width]="mapWidth"
  [height]="mapHeight"
  [layers]="layers"
></ejs-maps>
